import { TextCodes } from '@api/types/translation/TextCodes';
import { WarrantyFileCard, useWarrantyClaimContext } from '@components';
import { Box, Button, FormControl, Input } from '@mui/material';
import { t } from '@translations';
import { Controller } from 'react-hook-form';

export const WarrantyFileUpload = () => {
  const { form, isReadOnly } = useWarrantyClaimContext();
  const currentFile = form.watch('recipeFile');

  return (
    <Controller
      control={form.control}
      name='recipeFile'
      render={({ field }) => {
        return (
          <FormControl>
            {!currentFile?.length && (
              <Box width='fit-content' sx={{ mt: 5 }} className='warranty-file-upload'>
                <Button component='label' variant='primary' size='small' disabled={isReadOnly}>
                  {t(TextCodes.Warranty.Block.UploadRecipe)}
                  <Input
                    {...field}
                    value={field?.value?.fileName}
                    onChange={(event) => {
                      const target = event.target as HTMLInputElement;
                      if (target.files) {
                        field.onChange(target.files[0]);
                        form.setValue('recipeFile', [target.files[0]]);
                      }
                    }}
                    type='file'
                    id='recipeFile'
                    inputProps={{ accept: '.pdf,.jpg,.jpeg,.png' }}
                    sx={{ display: 'none' }}
                  />
                </Button>
              </Box>
            )}

            {!!currentFile?.length && (
              <Box
                sx={{
                  mt: {
                    xs: 2,
                    lg: 0,
                  },
                }}
              >
                <WarrantyFileCard />
              </Box>
            )}
          </FormControl>
        );
      }}
    />
  );
};
